import { SpinnerIcon } from "components/Icons";
import styles from "./Loader.module.css";

export const LoaderContainer = () => (
  <div className={styles.container}>
    <Loader />
  </div>
);

const Loader = () => (
  <div className={styles.loader}>
    <SpinnerIcon />
  </div>
);
